import * as React from 'react';
import {
  Header,
  staticMenu,
  Footer,
  Container,
  // Eyebrow,
  // Row,
  ReactRouterLinkProvider,
  initializeLibraryI18n,
} from '@elevationscu/ui-component-lib';
import enTranslations from '@elevationscu/ui-component-lib/dist/locales/en/common.json';
import esTranslations from '@elevationscu/ui-component-lib/dist/locales/es/common.json';
import i18n from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import styles from './App.module.scss';
// import prospectPut from './components/helper-functions';
import Page1 from './components/page1';
import Page2 from './components/page2';
import Page3 from './components/page3';

export const userContext = React.createContext();

const options = {
  debug: process.env.NODE_ENV === 'development',

  // Language to use (overrides detected language)
  lng: 'en-US',
  // Fallback Language that will be used if translations in selected lng are not available
  fallbackLng: 'en-US',
  // Ignore the country code when looking up the locale file
  load: 'languageOnly',

  // Array of namespaces to load
  ns: [],
  // Default namespace used if not passed to translation function
  defaultNS: 'common',

  // Array of allowed, non-explicit languages w/o country codes
  whitelist: ['en', 'es'],
  nonExplicitWhitelist: true,

  // Whether to load locales asynchronously immediately after calling init routine
  // https://www.i18next.com/overview/configuration-options#initimmediate
  initImmediate: false,

  // Whether to save missing keys through the backend
  saveMissing: false,

  interpolation: {
    // not needed for react as it escapes by default
    escapeValue: false,
  },
};

// Initialize React integration
i18n.use(initReactI18next);

// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
if (!i18n.isInitialized) {
  i18n.init(options);
}

initializeLibraryI18n({
  resources: {
    en: {
      common: enTranslations,
    },
    es: {
      common: esTranslations,
    },
  },
  fallbackLng: 'en',
  lng: 'en-US',
  interpolation: {
    escapeValue: false,
  },
  defaultNS: 'common',
});

function App() {
  const page1 = 1;
  const page2 = 2;
  const page3 = 3;
  const maxPages = 3;
  const [pageNumber, setPageNumber] = React.useState(1);

  const [userInfo, setUserInfo] = React.useState({
    email: null,
    phone: null,
    application_data: {},
    app_status: null,
  });

  function nextPage(info) {
    setUserInfo(info);
    // prospectPut(info);
    // console.log('API call to PUT info');
    setPageNumber(pageNumber + 1);
  }

  function previousPage(_info) {
    // setUserInfo(userInfo);
    // prospectPut(userInfo);  //  Commented out temporarily to prevent validation errors when previous is hit before filling out that 'page'
    setPageNumber(pageNumber - 1);
  }

  // This is just for debugging, this shall be taken out when we hook up the API.
  React.useEffect(() => {
    // console.log('userInfo', userInfo);
  }, [userInfo, userInfo.application_data]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className={styles.mainContainer}>
      <div className={styles.requestHeader}>
        <strong className={styles.requestHeaderSubText}>
          REQUEST A BUSINESS HOME EQUITY LINE OF CREDIT
        </strong>
      </div>
      <div className={styles.coreData}>
        <Container>
          {
          (() => {
            switch (pageNumber) {
              case page1:
                return (
                  <Page1
                    userInfo={userInfo}
                    setUserInfo={setUserInfo}
                    pageNumber={pageNumber}
                    nextPage={nextPage}
                    previousPage={previousPage}
                    maxPages={maxPages}
                  />
                );
              case page2:
                return (
                  <Page2
                    userInfo={userInfo}
                    setUserInfo={setUserInfo}
                    pageNumber={pageNumber}
                    nextPage={nextPage}
                    previousPage={previousPage}
                    maxPages={maxPages}
                  />
                );
              case page3:
                return (
                  <Page3
                    userInfo={userInfo}
                    setUserInfo={setUserInfo}
                    pageNumber={pageNumber}
                    nextPage={nextPage}
                    previousPage={previousPage}
                    maxPages={maxPages}
                  />
                );
              default:
                console.error('Page does not exist');
            }
          })()
        }
        </Container>
      </div>
    </div>
  );
}

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <App />,
    }],
  { basename: `${process.env.REACT_APP_PUBLIC_URL}` },
);

function AppWithRouterAccess() {
  const pageContext = {
    langKey: 'en-US',
    pathname: '/',
  };
  return (

    <div>
      <I18nextProvider i18n={i18n}>
        <ReactRouterLinkProvider>
          <Header
            env={process.env.REACT_APP_ENV_PUBLIC_WEB_ADDRESS}
            location={{ pathname: `${process.env.REACT_APP_ENV_PUBLIC_WEB_ADDRESS}`, search: '' }}
            pageContext={pageContext}
            menu={staticMenu}
            translationOn={false}
          />
          <RouterProvider
            router={router}
          />
          <div className={styles.footerHelp}>
            <Footer menu={staticMenu} env={process.env.REACT_APP_ENV_PUBLIC_WEB_ADDRESS} />
          </div>
        </ReactRouterLinkProvider>
      </I18nextProvider>
    </div>
  );
}

export default AppWithRouterAccess;
